$.fn.isOnScreen = function (buffer = 300) {
  var win = $(window);

  var viewport = {
    top: win.scrollTop() - buffer,
    left: win.scrollLeft() - buffer,
  };
  viewport.right = viewport.left + win.width() + (buffer * 2);
  viewport.bottom = viewport.top + win.height() + (buffer * 2);

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

// OLD JQUERY
$(document).ready(function () {

  loadVariantProducts();

   // Direct de eerste 4 color-variants laden
  //  $(".product-card .color-variants").slice(0, 4).each(function () {
  //   loadPoductColors($(this), 0);
  // });

  // $(window).scroll(function(){
  //   var productIndex = 0;
  // $(".product-card .color-variants").each(function () {
  //   var cur = $(this);
  //   var productIndex;
  //     if (cur.isOnScreen()) {
  //       productIndex++;
  //       loadPoductColors(cur, productIndex);
  //     }
  //   });
  // });

  /* VIDEO POPUP Productpage */
  Fancybox.bind(".video-popup-button", {
    Video: {
      autoplay: true,
      ratio: 16 / 9,
    },
  });
  /* END VIDEO POPUP Productpage */
});


function loadPoductColors(cur, index) {
  if (!cur.hasClass("prod-loaded")) {
    cur.addClass("prod-loaded");

    var productTag = cur.data("prod-tags");
    
    // Parse de color map
    const colorMap = new Map();
    const colorMapString = cur.data("color-map");
    if (colorMapString) {
      colorMapString.split(',').forEach(pair => {
        const [number, hexColor] = pair.split(':');
        colorMap.set(number, hexColor);
      });
    }

    if (productTag) {
      $.get(
        "/search/suggest.json?type=product&q=variant_" +
          productTag +
          "&resources%5Boptions%5D%5Bfields%5D=tag",
        function (data) {
          var prodData = data.resources.results.products;
          var colorHtml = "";
          
          // Bijhouden van verwerkte URLs
          const processedUrls = new Set();

          $.each(prodData, function (index, product) {
            var url = "/products/" + product.handle;
            var productTags = product.tags;

            $.each(productTags, function (index, tag) {
              if (tag.indexOf("variant_") >= 0) {
                // Check of deze URL al is verwerkt
                if (processedUrls.has(url)) {
                  return; // Skip als de URL al bestaat
                }

                var tagSplit = tag.split("-");
                var variantColor = tagSplit[1];
                
                // Haal de hex kleur op uit de colorMap
                const hexColor = colorMap.get(variantColor) || '';
                let backgroundStyle = '';
                
                if (hexColor.includes('.SPLIT.')) {
                  const [color1, color2] = hexColor.split('.SPLIT.');
                  backgroundStyle = `background: linear-gradient(45deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
                } else {
                  backgroundStyle = `background-color: ${hexColor}`;
                }

                colorHtml += `
                  <li class="splide__slide">
                    <a href="${url}" 
                       class="product-card-color color-block-${variantColor}"
                       style="${backgroundStyle}">
                    </a>
                  </li>`;
                
                // Voeg URL toe aan verwerkte URLs
                processedUrls.add(url);
              }
            });
          });

          // Voeg de HTML toe aan de slider
          cur.find('.splide__list').html(colorHtml);
          
          // Initialiseer de Splide slider
          if (colorHtml !== "") {
            new Splide(cur.find('.splide')[0], {
              perPage: 7,
              gap: '0px',
              pagination: false,
              // fixedWidth: 15,
              // fixedHeight: 15,
              arrows: true,
              drag: true,
              perMove: 3,
              breakpoints: {
                640: {
                  perPage: 5
                }
              }
            }).mount();
          }
        }
      );
    }
  }
}


function loadVariantProducts() {
  var variantTags = $(".product-tags").attr("data-tags");
  var variantSettings = $(".product-tags").attr("data-variant-setting");
  var variantTagComplete = $(".product-tags").attr("data-tags-complete");
  // Parse de color map
  const colorMap = new Map();
  const colorMapString = $(".product-tags").attr("data-color-map");
  if (colorMapString) {
    colorMapString.split(',').forEach(pair => {
      const [number, hexColor] = pair.split(':');
      colorMap.set(number, hexColor);
    });
  }

  if (variantTags) {
    $.get(
      "/search/suggest.json?type=product&q=" +
        variantTags +
        "&resources%5Boptions%5D%5Bfields%5D=tag",
      function (data) {
        var prodData = data.resources.results.products;
        var completeHtml = "";
        var productHtml = "";

         // Sorteer de producten zodat de actieve variant eerst komt
         prodData.sort((a, b) => {
          const aIsActive = a.tags.includes(variantTagComplete);
          const bIsActive = b.tags.includes(variantTagComplete);
          return bIsActive - aIsActive; // Active items komen eerst
        });
        
        // Bijhouden van verwerkte kleur URLs
        const processedColorUrls = new Set();

        $.each(prodData, function (index, product) {
          if (variantSettings == "images") {
            var url = "/products/" + product.handle;
            productHtml += '<li class="splide__slide">';
            // productHtml += '<a class="variant-inner" href="' + url + '">';
            productHtml += '<a class="variant-inner ' + (product.tags.includes(variantTagComplete) ? 'active' : '') + '" href="' + url + '">';
            productHtml += '<img src="' + product.image + '" width="1000" height="1000" />';
            productHtml += "</a>";
            productHtml += "</li>";
          } else {
            var productTags = product.tags;
            $.each(productTags, function (index, tag) {
              if (tag.indexOf("variant_") >= 0) {
                var tagSplit = tag.split("-");
                var variantColor = tagSplit[1];
                var colorUrl = "/products/" + product.handle;
                
                // Check of deze kleur URL al is verwerkt
                if (processedColorUrls.has(colorUrl)) {
                  return; // Skip deze kleur als de URL al bestaat
                }
                
                const hexColor = colorMap.get(variantColor) || '';
                let backgroundStyle = '';
                
                if (hexColor.includes('.SPLIT.')) {
                  const [color1, color2] = hexColor.split('.SPLIT.');
                  backgroundStyle = `background: linear-gradient(45deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
                } else {
                  backgroundStyle = `background-color: ${hexColor}`;
                }

                productHtml += '<li class="splide__slide">';
                productHtml +=
                  '<a class="color-block color-block-' +
                  variantColor +
                  '" href="' +
                  colorUrl +
                  '" style="' + backgroundStyle + '">';
                productHtml += "</a>";
                productHtml += "</li>";
                
                // Voeg de kleur URL toe aan verwerkte URLs
                processedColorUrls.add(colorUrl);
              }
            });
          }
        });

        completeHtml += productHtml;
        $(".sm-variants-wrap .splide__list").html(completeHtml);
        $(".variants-slider").addClass("loaded");
        mountVariantSlider();
      }
    );
  }
}

function mountVariantSlider() {
  var variantSlider = $(".productpage-tags");
  var variantSettings = $(".product-tags").attr("data-variant-setting");
  var fixedWidth = 1;
  var fixedHeight = 1;

  if (variantSettings == "images") {
    fixedWidth = 75;
    fixedHeight = 75;
  } else if (variantSettings == "colors") {
    fixedWidth = 30;
    fixedHeight = 30;
  }

  if (variantSlider.length > 0) {
    const variantsSlider = new Splide(".variants-slider", {
      type: "slide",
      // perPage: 7,
      gap: 10,
      pagination: false,
      fixedWidth: fixedWidth,
      fixedHeight: fixedHeight,
      speed: 700,
      perMove: 3,
      drag: true,
      loop: false,
      arrows: true,
      breakpoints: {
        767: {
          perPage: 4,
        },
      },
    });

    variantsSlider.on("overflow", function (isOverflow) {
      if (!isOverflow) {
        variantsSlider.options = {
          arrows: false,
          drag: false,
        };
      }
    });

    variantsSlider.mount();
  }
}

// PROMO COUNTDOWN SECTION
const PromoCountdown = class extends HTMLElement {
  connectedCallback() {
    console.log("PromoCountdown connected");
  }
};

if (!window.customElements.get("promo-countdown")) {
  window.customElements.define("promo-countdown", PromoCountdown);
}